import {
    $, addAction, INIT, LAYOUTEND,
} from '@situation/setdesign.util';
import { sceneController, getSceneDuration } from '../../shared/animations/setup';
import { BREAKPOINTS } from '../../shared/theme-globals';

/* global ScrollMagic, TweenMax, Power0 */
addAction(INIT, () => {
    let previousViewportWidth = 0;

    const createScene = (options) => {
        const scene = new ScrollMagic.Scene({ ...options });
        scene.addTo(sceneController);
        return scene;
    };

    const initializeScenes = () => {
        const currentViewportWidth = SetDesign.viewport.width();
        if (
            previousViewportWidth
            && ((currentViewportWidth < BREAKPOINTS.lg && previousViewportWidth < BREAKPOINTS.lg)
                || (currentViewportWidth >= BREAKPOINTS.lg && previousViewportWidth >= BREAKPOINTS.lg))
        ) {
            return;
        }

        previousViewportWidth = currentViewportWidth;
        $('.call-to-action-list').each((index, element) => {
            const $list = $(element);
            const $items = $list.find('li');
            if ($items.length < 2) {
                return;
            }

            const options = { triggerElement: element, triggerHook: 1, duration: getSceneDuration.bind(element) };
            const scenes = $list.data('scenes') || { odd: createScene(options), even: createScene(options) };
            TweenMax.set($items.get(), { clearProps: 'all' });
            let tweenOdd;
            let tweenEven;
            if ($list.hasClass('call-to-action-list--block') && currentViewportWidth >= BREAKPOINTS.lg) {
                tweenOdd = TweenMax.fromTo($items.filter(':first-child'), 1, { y: '30%' }, { y: '-5%' });
                tweenEven = TweenMax.fromTo($items.filter(':nth-child(2)'), 1, { y: '30%' }, { y: '-5%' });
            } else {
                tweenOdd = TweenMax.from($items.filter(':odd'), 1, { x: '-5%', ease: Power0.easeNone });
                tweenEven = TweenMax.from($items.filter(':even'), 1, { x: '5%', ease: Power0.easeNone });
            }

            scenes.odd.setTween(tweenOdd);
            scenes.even.setTween(tweenEven);
            $list.data('scenes', scenes);
        });
    };

    addAction(LAYOUTEND, initializeScenes);
});
